/**
 * Membership FAQ (CB)
 * Accordion FAQ with maxHeight animation.
 * Only one item open at a time (accordion mode).
 * Uses the same maxHeight toggle pattern as halo-faqs.js.
 */

class CbMembershipFaq extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.cb-membership-faq__question');
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.onToggle.bind(this));
    });
  }

  onToggle(event) {
    const button = event.currentTarget;
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    const answerId = button.getAttribute('aria-controls');
    const answer = document.getElementById(answerId);

    if (!answer) return;

    // Accordion mode: close all other items first
    if (!isExpanded) {
      this.closeAll(button);
    }

    // Toggle the clicked item
    if (isExpanded) {
      button.setAttribute('aria-expanded', 'false');
      answer.style.maxHeight = null;
    } else {
      button.setAttribute('aria-expanded', 'true');
      answer.style.maxHeight = answer.scrollHeight + 'px';
    }
  }

  closeAll(exceptButton) {
    this.buttons.forEach((button) => {
      if (button === exceptButton) return;
      if (button.getAttribute('aria-expanded') === 'true') {
        const answerId = button.getAttribute('aria-controls');
        const answer = document.getElementById(answerId);
        button.setAttribute('aria-expanded', 'false');
        if (answer) {
          answer.style.maxHeight = null;
        }
      }
    });
  }
}

customElements.define('cb-membership-faq', CbMembershipFaq);
